import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from "@angular/forms";
import {TextUtils} from "../../../../../shared/utils/text-utils";
import {IOrder, OrderStatusEnum} from "../orders.interface";
import {IDsDropdownOption} from "../../../../../shared/components/ds-dropdown/ds-dropdown-option";
import {IDropdownListItem} from "../../../../../shared/components/dropdown-list/dropdown-list-item";
import {NotificationModalComponent} from "../../../../../shared/components/dialogs/notification-modal/notification-modal.component";
import {DbModalService} from "../../../../../modules/modal/modal";
import {RefundItemsPopupComponent} from "../refund-items-popup/refund-items-popup.component";
import * as fromStore from "../../../../../store";
import {Store} from "@ngrx/store";
import {RefundData} from "../mapper/refund-data";
import {Router} from "@angular/router";

@Component({
    selector: 'db-order-table-row',
    templateUrl: './order-table-row.component.html',
    styleUrls: ['./order-table-row.component.scss'],
    standalone: false
})
export class OrderTableRowComponent implements OnInit {
  @Input() order: IOrder;
  @Input() websiteId: number;
  fullRefunded: boolean = false;
  refunds: RefundData[];
  statusOptions: IDsDropdownOption[] = [
    {
      value: OrderStatusEnum.PENDING,
      label: TextUtils.getText('text_pending')
    },
    {
      value: OrderStatusEnum.PROCESSING,
      label: TextUtils.getText('text_processing')
    },
    {
      value: OrderStatusEnum.ON_HOLD,
      label: TextUtils.getText('text_onHold')
    },
    {
      value: OrderStatusEnum.COMPLETED,
      label: TextUtils.getText('text_completed')
    },
    {
      value: OrderStatusEnum.CANCELLED,
      label: TextUtils.getText('text_cancelled')
    },
    {
      value: OrderStatusEnum.REFUNDED,
      label: TextUtils.getText('text_refunded')
    },
    {
      value: OrderStatusEnum.FAILED,
      label: TextUtils.getText('text_failed')
    },
    {
      value: OrderStatusEnum.DRAFT,
      label: TextUtils.getText('text_draft')
    },
  ];

  status: FormControl = new FormControl();
  @Output() statusChanged: EventEmitter<{ status: string; orderId: number }> = new EventEmitter<{
    status: string;
    orderId: number
  }>();
  @Output() removeItem: EventEmitter<number> = new EventEmitter<number>();
  dropdownOptions: Array<IDropdownListItem> = [{
    action: this.onRemoveItem.bind(this),
    label: TextUtils.getText('text_removeOrder')
  }];

  constructor(
    private _modalService: DbModalService,
    private _store: Store<fromStore.DbStoreState>,
    private _router: Router,
  ) {
  }

  ngOnInit() {
    let refundsTotalSum = 0;
    this.order?.refunds.forEach(item => {
      refundsTotalSum += parseFloat(item?.total);
    });

    this.fullRefunded = (Math.abs(refundsTotalSum) === +this.order?.total);
  }

  statusChange(status: string, orderId: number, partlyRefunded: boolean) {
    if (status === 'refunded' && !this.fullRefunded) {
      this.handleRefundSectionToggle(!partlyRefunded);
    }
    else {
      const confirmationModal = this._modalService.open(NotificationModalComponent, {width: 500});
      confirmationModal.componentInstance.header = TextUtils.getText('text_orderStatusUpdate');
      confirmationModal.componentInstance.buttonTxt = TextUtils.getText('text_update');
      confirmationModal.componentInstance.message = TextUtils.getText('text_areYouSureYouWantToChangeOrderStatus');
      confirmationModal.componentInstance.discardButtonTxt = TextUtils.getText('text_discard');
      confirmationModal.componentInstance.buttonAdditionalClass = 'ds-btn-black';
      confirmationModal.closed.subscribe((value) => {
        value && this.statusChanged.emit({status, orderId});
      });
    }
  }

  handleRefundSectionToggle(fullRefund) {
    this._router.navigate(['/websites/' + this.websiteId + '/ecommerce/orders/order-view/' + this.order.id]);
    const modal = this._modalService.open(RefundItemsPopupComponent, {height: 600, width: 1240});
    modal.componentInstance.order = this.order;
    modal.componentInstance.fullRefund = fullRefund;
    modal.componentInstance.websiteId = this.websiteId;
    modal.componentInstance.getAttributes = this.getAttributes.bind(this);

    modal.componentInstance.onRefundSuccess = () => {
      this._store.dispatch(new fromStore.LoadEcommerceOrders({websiteId: this.websiteId}));
      this._store.dispatch(new fromStore.LoadEcommerceOrder({websiteId: this.websiteId, id: this.order?.id}));
      console.log("Dispatched action to reload order data");
    };
  }

  getAttributes(meta: any[]) {
    if (!meta) {
      return '';
    }
    return meta.filter(item => item.key !== "_reduced_stock" && item.value.length).map((item) => item.value).join(', ');
  }


  onRemoveItem() {
    this.removeItem.emit(this.order.id);
  }

  toCamelCase(str) {
    return str
        .toLowerCase()
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (match, index) =>
            index === 0 ? match.toLowerCase() : match.toUpperCase()
        )
        .replace(/\s+/g, '');
  }

}
